import React from 'react'

const Tab = ({ icon, active, click, title }) => {
  return (
    <div className='background-pestana-tab' onClick={() => click(title.toLowerCase())} title={title}>
      <div className={active ? 'pestana-tab active' : 'pestana-tab'}>
        <i className={icon}></i>
      </div>
    </div>
  )
}

export default Tab;